import { Component, OnInit ,EventEmitter,Output, Input, OnDestroy, OnChanges, SimpleChanges} from '@angular/core';
import { CreazionePraticaTipologicheService } from '../../../services/creazione-pratica-tipologiche.service';
import { Parte } from 'src/app/common/models/parte';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormValidationService } from 'src/app/common/services/form-validation.service';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Comune } from 'src/app/common/models/tipologiche/comune';
import { Provincia } from 'src/app/common/models/tipologiche/provincia';
import { SoggettoPratica } from 'src/app/common/models/tipologiche/soggetto-pratica';
import { TipoPersona } from 'src/app/common/models/tipologiche/tipo-persona';
import { TipoSocieta } from 'src/app/common/models/tipologiche/tipo-societa';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';
import { Subject } from 'rxjs';
import { CreazionePraticaStoreService } from '../../../services/creazione-pratica-store.service';
import { TipoFascicolo } from 'src/app/common/models/tipologiche/tipo-fascicolo';
@Component({
  selector: 'app-anagrafica-parte-form',
  templateUrl: './anagrafica-parte-form.component.html',
  styleUrls: ['./anagrafica-parte-form.component.css']
})
export class AnagraficaParteFormComponent implements OnInit,OnChanges, OnDestroy {

  PropertiesSettings: PropertiesSettings;
  comuniNascitaOptions: Comune[] = [];
  comuniResidenzaOptions: Comune[] = [];
  provinciaOptions: Provincia[] = [];
  societaOptions: SoggettoPratica[] = [];
  tipoPersonaOptions: TipoPersona[] = [];
  tipoSocietaOptions: TipoSocieta[] = [];
  tipoFascicolo: TipoFascicolo = null;
  currentTipo: string;

  public soggettoForm: FormGroup;
  @Output() parteChange: EventEmitter<Parte> = new EventEmitter<Parte>();
  @Input() parte: Parte;
  @Input() isParteForm: boolean = false;
  @Input() labelButton: string = "Inserisci e associa";
  @Input() hasDetailsAnagrafica:boolean;

  componentDestroyed$: Subject<void> = new Subject<void>();

  constructor(
    private campiForm: FormBuilder,
    private tipologicheService: CreazionePraticaTipologicheService,
    private formValidationService: FormValidationService,
    private creazionePraticaStore: CreazionePraticaStoreService
  ) {
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(this.hasDetailsAnagrafica){
      this.createForm();
    }
  }

  ngOnInit(): void {

    this.creazionePraticaStore.tipoFascicolo$.pipe(takeUntil(this.componentDestroyed$))
    .subscribe(response => this.tipoFascicolo = response);
    this.createForm();
    this.populateSelect();
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next();
  }

  createForm() {
    let isSessoDisabled = true;
    let sessoValueBoolean = undefined;
    console.log(this.parte);
    if(this.parte == null) {
      this.parte = new Parte();
      this.currentTipo = null;
    }
    else {
      this.currentTipo = this.parte.tipoPersona != null ? this.parte.tipoPersona.label : null;
      if(this.currentTipo == PropertiesSettings.LABEL_TIPO_PERSONA_FISICA){
        isSessoDisabled = false;
        if(this.parte.sesso){
          sessoValueBoolean = this.parte.sesso === 'M' ? true : false;
        }
      }
    }
    this.soggettoForm = this.campiForm.group({
      tipoPersona: [this.parte.tipoPersona, Validators.required],
      nome: [this.parte.nome,
        Validators.compose([this.formValidationService.lettere])],
      cognome: [this.parte.cognome,
        Validators.compose([this.formValidationService.lettere])],
      codiceFiscale: [
        this.parte.codiceFiscale,
        Validators.compose([this.formValidationService.codiceFiscale])
      ],
      dipendente: [this.parte.dipendente],
      sesso: [{value: sessoValueBoolean , disabled: isSessoDisabled}],
      matricola: [{
        value: this.parte.matricola, disabled: this.parte.dipendente},
        Validators.compose([this.formValidationService.numeri])
      ],
      societa: [this.parte.societa],
      ragioneSociale: [
        this.parte.ragioneSociale
      ],
      partitaIva: [
        this.parte.partitaIva,
        Validators.compose([this.formValidationService.partitaIva])
      ],
      codiceFiscaleRappresentanteLegale: [
        this.parte.codiceFiscaleRappresentanteLegale,
        Validators.compose([
          this.formValidationService.codiceFiscaleRappresentanteLegale
        ])
      ],
      tipoSocieta: [this.parte.tipoSocieta],
      dataNascita: [this.parte.dataNascita],
      provinciaNascita: [this.parte.provinciaNascita],
      comuneNascita: [this.parte.comuneNascita],
      indirizzo: [this.parte.indirizzo],
      cap: [this.parte.cap, Validators.compose([this.formValidationService.cap])],
      provinciaResidenza: [this.parte.provinciaResidenza],
      comuneResidenza: [this.parte.comuneResidenza],
      telefono: [
        this.parte.telefono,
        Validators.compose([this.formValidationService.telefono]),
      ],
      cellulare: [
        this.parte.cellulare,
        Validators.compose([this.formValidationService.telefono]),
      ],
      fax: [this.parte.fax, Validators.compose([this.formValidationService.telefono])],
      email: [this.parte.email, Validators.compose([this.formValidationService.email])],
      pec: [this.parte.pec, Validators.compose([this.formValidationService.email])],
      note: [this.parte.note],
    });
    if(this.isFascicoloSanitario()) this.soggettoForm.addControl("vivente", new FormControl((this.parte.vivente != null) ? this.parte.vivente : null));
    this.soggettoForm.get('tipoPersona').valueChanges.pipe(distinctUntilChanged()).subscribe(value => this.onChangeTipoPersona(value));
    this.soggettoForm.get('dipendente').valueChanges.pipe(distinctUntilChanged()).subscribe(value =>
      value ?  this.soggettoForm.get('matricola').enable() : this.soggettoForm.get('matricola').disable()
    );
    this.soggettoForm.get('provinciaNascita').valueChanges.pipe(distinctUntilChanged()).subscribe(value => {
      if(value && value.id){
        this.tipologicheService.getComuniNascita(value.id).subscribe(response => this.comuniNascitaOptions = response);
      };
    });
    this.soggettoForm.get('provinciaResidenza').valueChanges.pipe(distinctUntilChanged()).subscribe(value => {
      if(value && value.id){
        this.tipologicheService.getComuniResidenza(value.id).subscribe(response => this.comuniResidenzaOptions = response);
      };
    });;

  }

  submit() {
    console.log(this.soggettoForm);
    if(this.soggettoForm.valid){
      let id = this.parte.id;
      this.parte = this.soggettoForm.getRawValue();
      this.parte.rimosso = false;
      this.parte.tipoPersona.rimosso = false;
      if(this.parte.sesso !== undefined){
        if(typeof(this.parte.sesso) === "boolean"){
          this.parte.sesso = this.parte.sesso ? 'M' : 'F'
        }
      }
      if(id) this.parte.id = id;
      this.parteChange.emit(this.parte);
    }
  }

  populateSelect() {
    this.tipologicheService
      .getTipiPersona()
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((response) => (this.tipoPersonaOptions = response));
    this.tipologicheService
      .getTipiSocieta()
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((response) => (this.tipoSocietaOptions = response));
    this.tipologicheService
      .getProvince()
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((response) => (this.provinciaOptions = response));
    this.tipologicheService
      .getSocieta()
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((response) => (this.societaOptions = response));
  }

  onChangeTipoPersona(tipoPersona: TipoPersona) {
    if(tipoPersona == null){
      this.currentTipo = null;
      if(this.isFascicoloSanitario()){
        this.soggettoForm.get('vivente').setValue(null);
        this.soggettoForm.get('vivente').disable();
      }
      this.soggettoForm.get('sesso').setValue(null);
      this.soggettoForm.get('sesso').disable();
      this.soggettoForm.controls["nome"].setValidators([]);
      this.soggettoForm.controls["cognome"].setValidators([]);
      this.soggettoForm.controls["sesso"].setValidators([]);
      this.soggettoForm.controls["ragioneSociale"].setValidators([]);
    }
    else if (tipoPersona.label == PropertiesSettings.LABEL_TIPO_PERSONA_FISICA) {
      this.currentTipo = PropertiesSettings.LABEL_TIPO_PERSONA_FISICA;
      if(this.isFascicoloSanitario()){
        this.soggettoForm.get('vivente').enable();
        this.soggettoForm.get('vivente').setValue(true);
      }
      this.soggettoForm.get('sesso').enable();
      this.soggettoForm.get('sesso').setValue(true);
      this.soggettoForm.controls["nome"].setValidators([Validators.required,this.formValidationService.lettere]);
      this.soggettoForm.controls["cognome"].setValidators([Validators.required,this.formValidationService.lettere]);
      this.soggettoForm.controls["sesso"].setValidators([Validators.required]);
      this.soggettoForm.controls["ragioneSociale"].setValidators([]);
    } else if (tipoPersona.label == PropertiesSettings.LABEL_TIPO_PERSONA_GIURIDICA) {
      this.currentTipo = PropertiesSettings.LABEL_TIPO_PERSONA_GIURIDICA;
      if(this.isFascicoloSanitario()){
        this.soggettoForm.get('vivente').setValue(null);
        this.soggettoForm.get('vivente').disable();
      }
      this.soggettoForm.get('sesso').setValue(null);
      this.soggettoForm.get('sesso').disable();
      this.soggettoForm.controls["nome"].setValidators([]);
      this.soggettoForm.controls["cognome"].setValidators([]);
      this.soggettoForm.controls["sesso"].setValidators([]);
      this.soggettoForm.controls["ragioneSociale"].setValidators([Validators.required]);
    }
    if(this.isFascicoloSanitario()) this.soggettoForm.controls["vivente"].updateValueAndValidity();
    this.soggettoForm.controls["nome"].updateValueAndValidity();
    this.soggettoForm.controls["cognome"].updateValueAndValidity();
    this.soggettoForm.controls["sesso"].updateValueAndValidity();
    this.soggettoForm.controls["ragioneSociale"].updateValueAndValidity();
  }

  onChangeSesso(event: boolean){
    this.parte.sesso = event ? "M" : "F";
  }

  isFascicoloSanitario(){
    return (this.isParteForm && this.tipoFascicolo != null && this.tipoFascicolo.label == 'SINISTRO SANITARIO');
  }

}
